import styled from 'styled-components'

import { ModalBodyContainer } from 'components/modal/styled'

export const ModalBody = styled(ModalBodyContainer)`
  form > button {
    margin: ${({ theme }) => theme.spacings[6]} auto;
  }
`
